import { render, staticRenderFns } from "./voteInfo.vue?vue&type=template&id=02808161&scoped=true"
import script from "./voteInfo.vue?vue&type=script&lang=js"
export * from "./voteInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02808161",
  null
  
)

export default component.exports